module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "MAIN_PAGE",
    attrs: {
      "id": "d5e395"
    }
  }, [_c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151211"
    }
  }, [_c('b', [_vm._v("First published in Great Britain in 1996 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151212"
    }
  }, [_c('b', [_vm._v("by William Heinemann Ltd, ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151213"
    }
  }, [_c('b', [_vm._v("and imprint of Reed International Books Ltd ")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d128401"
    }
  }, [_c('b', [_vm._v("Copyright © 1996 by Hugh Laurie ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d128402"
    }
  }, [_c('b', [_vm._v("The")]), _c('b', [_vm._v(" author has asserted his moral rights.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151351"
    }
  }, [_c('b', [_vm._v("All rights reserved.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151381"
    }
  }, [_c('b', [_vm._v("Published by ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151382"
    }
  }, [_c('b', [_vm._v("Soho Press, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151383"
    }
  }, [_c('b', [_vm._v("853 Broadway ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d41151384"
    }
  }, [_c('b', [_vm._v("New York NY 10003 ")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "tx41"
  }, [_c('p', {
    staticClass: "tx12",
    attrs: {
      "id": "d128541"
    }
  }, [_c('b', [_vm._v("Library of Congress Catalog in Publishing Data ")]), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d128661"
    }
  }, [_c('b', [_vm._v("Laurie, Hugh, 1959-")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d128662"
    }
  }, [_c('b', [_vm._v("The gun seller / Hugh Laurie ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d128663"
    }
  }, [_c('b', [_vm._v("p. cm.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d41151561"
    }
  }, [_c('b', [_vm._v("ISBN 1-56947-087-1 (alk. paper) ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d41151562"
    }
  }, [_c('b', [_vm._v("I. Tide.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d41151611"
    }
  }, [_c('b', [_vm._v("PR6062.A8139G8 1997 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx13",
    attrs: {
      "id": "d128921"
    }
  }, [_c('b', [_vm._v("823' .914-dc21")])]), _vm._v(" "), _c('p', {
    staticClass: "tx13",
    staticStyle: {
      "text-align": "right",
      "margin-right": "20%",
      "margin-top": "-1em"
    }
  }, [_c('b', [_vm._v("96-46813 ")]), _c('br'), _c('b', [_vm._v("CIP ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx13a",
    attrs: {
      "id": "d129001"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tx42"
  }), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "d129071"
    }
  }, [_c('b', [_vm._v("10  9  8 7 6  5 4 3 2 ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cb35a18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap5_thegunse_9781569478004_epub_part5.vue
// module id = 66
// module chunks = 0